import { TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { TextFieldProps } from "@material-ui/core/TextField";

const ObaTextField: React.ComponentType<TextFieldProps> = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "#656565",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#656565",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#656565",
      },
      "&:hover fieldset": {
        borderColor: "#656565",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#656565",
      },
    },
  },
})(TextField);

export default ObaTextField;